//bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TreeNodeViewModel from "./../../factories/tree-node";
import BaoMenu from "./../../services/bao-menu";
import BaoDialog from "./../../factories/bao-dialog";
import "./../../bindings/bao-tree";
import "./../../bindings/sorting";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-toolbar2";
function ChecklistEvaluationViewModel(tabPage) {
    var self = this;
    self.TabTitle = Bao.Session.GetMessage("msgChecklists");
    var titleHelper = ko.computed(function () {
        tabPage.Title(self.TabTitle());
    });
    self.PermissionEvaluationSaveOtherUser = Bao.Session.HasPermission("EvaluationSaveOtherUser", window["CheckwareApplicationId"]);
    self.SelectedNode = ko.observable(null);
    self.ResetInProgress = ko.observable(false);
    self.Initialized = ko.observable();
    self.TotalRows = ko.observable(0);
    self.Nodes = ko.observableArray([]);
    self.Columns = ko.observableArray([]);
    self.ChecklistCollection = ko.observableArray([]);
    self.Sorting = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.SelectedRow = ko.observable();
    self.IncompleteMode = ko.observable(false);
    self.ShowTrashcan = false;
    var _deleteEvaluationMessage = Bao.Session.GetMessage("msgDeleteEvaluation");
    self.Sorting.subscribe(function () {
        if (self.Initialized() == true && self.ResetInProgress() == false) {
            self.LoadChecklists(true);
        }
    });
    self.PageIndex.subscribe(function () {
        if (self.Initialized() == true && self.ResetInProgress() == false) {
            self.LoadChecklists(true);
        }
    });
    self.SelectedNode.subscribe(function () {
        self.IncompleteMode(!(self.SelectedNode() != null && self.SelectedNode().FolderStructureId() != null));
        if (self.SelectedNode() != null) {
            self.RefreshGrid();
        }
    });
    self.SelectedRow.subscribe(function (item) {
        var enabled = false;
        if (item != null && item.DeleteDate == null && self.IncompleteMode() && (item.InsertByUserId == Bao.Session.User.UserId() || self.PermissionEvaluationSaveOtherUser())) {
            enabled = true;
        }
        BaoMenu.permissionEnable({
            ActionKey: "ChecklistEvaluationDeleteIncomplete",
            Enabled: enabled,
            Context: tabPage.Context()
        });
    });
    var tabMenuClicked = function (permission) {
        if (tabPage.IsActiveTab()) {
            switch (permission.ActionKey()) {
                case "ChecklistEvaluationRefresh":
                    self.LoadOrgUnits();
                    break;
                case "ChecklistEvaluationDeleteIncomplete":
                    self.DeleteIncompleteChecklist();
                    break;
            }
        }
    };
    BaoMenu.registerEvent(tabMenuClicked);
    self.LoadTree = function () {
        tabPage.IsLoading(true);
        self.SelectedNode(null);
        self.ResetValues();
        return Bao.post("Checkware/ChecklistEvaluation/LoadTree", function (result) {
            var arrayNodes = [];
            ko.utils.arrayForEach(result, function (item) {
                arrayNodes[arrayNodes.length] = new TreeNodeViewModel(item, self);
            });
            self.Nodes(arrayNodes);
            tabPage.IsLoading(false);
            self.SelectedRow.valueHasMutated();
        });
    };
    self.LoadOrgUnits = function () {
        tabPage.IsLoading(true);
        self.ResetValues();
        return Bao.post("Checkware/ChecklistEvaluation/LoadOrgUnits", function (result) {
            var arrayNodes = [];
            ko.utils.arrayForEach(result, function (item) {
                arrayNodes[arrayNodes.length] = new TreeNodeViewModel(item, self);
            });
            self.Nodes(arrayNodes);
            tabPage.IsLoading(false);
            self.SelectedRow.valueHasMutated();
        });
    };
    self.LoadColumns = function () {
        return Bao.post("Checkware/ChecklistEvaluation/LoadColumns", JSON.stringify({
            key: self.SelectedNode().Key(),
            folderStructureId: self.SelectedNode().FolderStructureId()
        }));
    };
    self.LoadChecklists = function (independentRefresh) {
        tabPage.IsLoading(true);
        return Bao.post("Checkware/ChecklistEvaluation/LoadChecklists", JSON.stringify({
            key: self.SelectedNode().Key(),
            folderStructureId: self.SelectedNode().FolderStructureId(),
            sorting: self.Sorting(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize()
        }), function (result) {
            if (independentRefresh) {
                tabPage.IsLoading(false);
                self.ChecklistCollection(result.Models);
            }
        });
    };
    self.ResetValues = function () {
        self.ResetInProgress(true);
        self.Columns([]);
        self.TotalRows(0);
        self.PageIndex(0);
        self.ChecklistCollection([]);
        self.Sorting([]);
        self.SelectedRow(null);
        self.ResetInProgress(false);
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        self.ResetValues();
        return $.when(self.LoadColumns(), self.LoadChecklists()).then(function (columns, checklists) {
            self.Columns(columns[0]);
            self.ChecklistCollection(checklists[0].Models);
            self.TotalRows(checklists[0].TotalRows);
            tabPage.IsLoading(false);
        });
    };
    self.DeleteIncompleteChecklist = function (item) {
        if (item != null) {
            var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, _deleteEvaluationMessage, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    tabPage.IsLoading(true);
                    return Bao.post("Module/DeleteIncompleteEvaluation", JSON.stringify({
                        evaluationId: item.EvaluationId
                    }), function (deleteResult) {
                        self.RefreshGrid();
                    });
                }
            });
        }
    };
    self.init = function () {
        Bao.bindEvent("checkware:refresh_folderstructurechecklist", function () {
            self.LoadOrgUnits();
        });
        return self.LoadOrgUnits();
    };
    self.loaded = function () {
        self.Initialized(true);
    };
}
export default ChecklistEvaluationViewModel;